import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const START_LEFT = 9;
const MIN_LEFT = 3;
export function ScarcityBar() {
  const [left, setLeft] = useState(START_LEFT);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(prev => prev > MIN_LEFT ? prev - 1 : prev);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const claimed = Math.round((TOTAL_SPOTS - left) / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-2xl border-2 border-coral/30 bg-coral-soft p-4" data-id="element-54" data-mp="2g6ct0vuurqxu">
      <div className="flex items-center justify-between gap-3" data-id="element-55" data-mp="226bpf8n7e5eo">
        <p className="flex items-center gap-1.5 text-sm font-black text-coral sm:text-base" data-id="element-56" data-mp="227wo9agjwaic">
          <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-57" data-mp="275evmwex6ho8" />
          Only {left} spots left at the promotional price!
        </p>
        <span className="shrink-0 text-sm font-black text-navy" data-id="element-58" data-mp="5di9ytz1frfq">{claimed}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-59" data-mp="33mv4md77gz2k">
        <div className="h-full rounded-full bg-coral transition-[width] duration-300 ease-out" style={{
        width: `${claimed}%`
      }} data-id="element-60" data-mp="3dc6fo5dnkdt3" />
      </div>
      <p className="mt-2 text-xs font-bold text-ink/70" data-id="element-61" data-mp="2kn8xe29fyh0c">
        When these spots are gone, the price returns to the regular value.
      </p>
    </div>;
}